import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getRoles(): Observable<any> {
    return this.http.get(this.baseUrl + 'roles', { headers: this.header(this.token) });
  }

  getRolPorId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'rolPorId/' + id, { headers: this.header(this.token) });
  }

  postRol(Ods: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postRol', Ods, { headers: this.header(this.token) });
  }

  putRol(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putRol', bodyString, { headers: this.header(this.token) });
  }

  deleteRol(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteRol/' + id, { headers: this.header(this.token) });
  }

  getRolAsignadoUsuario(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'rolAsignadoUsuario/' + id, { headers: this.header(this.token) });
  }

  deleteRolAsignado(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteRolAsignado/' + id, { headers: this.header(this.token) });
  }

  postUsuarioRol(Rol: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postUsuarioRol', Rol, { headers: this.header(this.token) });
  }

  getVistas(): Observable<any> {
    return this.http.get(this.baseUrl + 'vistas', { headers: this.header(this.token) });
  }

  getVistasAsignadas(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'vistaAsignado/' + id, { headers: this.header(this.token) });
  }

  postVistaAsignado(vista: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postVistaRol', vista, { headers: this.header(this.token) });
  }

  deleteVistaAsignado(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteVistaAsignado/' + id, { headers: this.header(this.token) });
  }

}